import http from "@/settings/apiSettings"

class FunctiiDataService {
    save(data: any) : Promise<any> {
        return http.clientResurseUmaneOdata.post("/PER_Positions", data)
    }
}
export default new FunctiiDataService()